import { MultiPolygon } from 'geojson';

import { BASE_COLORS } from '@lib/ui/theme';

import { GoogleMap } from '../../map';
import { MapBaseOverlay } from '../base-overlay';
import { IMultiPolygonOptions } from './multi-polygon-options';
import { Polygon } from './polygon';
import { IPolygonEvents } from './polygon-events';
import { IPolygonOptions } from './polygon-options';

const DEFAULT_OPTIONS: IMultiPolygonOptions = {
  strokeOpacity: 0,
  fillColor: BASE_COLORS['primary-400'],
  strokeColor: BASE_COLORS['accent-400'],
  hoverFillCover: BASE_COLORS['accent-400'],
  paths: [],
};

export class MultiPolygonOverlay<
  TEvents extends IPolygonEvents = IPolygonEvents,
> extends MapBaseOverlay<TEvents> {
  private _polygons: Polygon[] = [];

  private _options: IMultiPolygonOptions;

  public constructor(options?: IMultiPolygonOptions, geojson?: MultiPolygon) {
    super(options);

    options = { ...DEFAULT_OPTIONS, ...options };
    this._options = options;
    this._createPolygons(geojson, options);
  }

  public setFillColor(color: string): void {
    this._polygons.forEach((poly) => poly.setFillColor(color));
  }

  protected onAdd(map: GoogleMap): void {
    this._polygons.forEach((poly) => {
      poly.addTo(map);
    });
  }

  protected onRemove(): void {
    this._polygons.forEach((poly) => {
      poly.remove();
    });
  }

  protected draw(): void {}

  private _createPolygons(geojson: MultiPolygon, options: IPolygonOptions): void {
    geojson.coordinates.forEach((coords) => {
      const paths = coords[0].map((position) => ({ lat: position[1], lng: position[0] }));
      const polygon = new Polygon({ ...options, paths });
      this._addEventListeners(polygon);
      this._polygons.push(polygon);
    });
  }

  private _addEventListeners(polygon: Polygon): void {
    polygon.on('mouseover').subscribe(() => {
      this.setFillColor(this._options.hoverFillCover);
    });

    polygon.on('mouseout').subscribe(() => {
      this.setFillColor(this._options.fillColor);
    });

    polygon.on('click').subscribe((event) => {
      this.fire('click', event, true);
    });
  }
}
